export default __webpack_public_path__ + "static/media/startpage-desktop-min.d6e8d3dd.jpg";